const WPVUE = window.WPVUE;

export default {
    getCurrentRoute: state => state.route,
    isTaxonomiesLoaded: state => state.taxonomiesLoaded,
    isFrontPage: (state, getters) => (getters.currentPage && Number(getters.currentPageID) === Number(WPVUE.page_on_front)),
    isArchive: state => (state.route.meta && state.route.meta.type && state.route.meta.type === 'archive') ? true : false,
    searchModalOpen: state => state.searchModalOpen,
    mainNaviIsOpen: state => state.mainNaviIsOpen,
    searchValue: state => state.searchValue,
    getOptions: state => state.options,
    featuredImage: (state, getters) => (getters.currentPage && getters.currentPage.featured_image) ? getters.currentPage.featured_image : false,
    currentPostType: state => (state.route.meta && state.route.meta.post_type) ? state.route.meta.post_type : 'page',
    currentPageID: (state, getters) => {
        let pageID = (getters.currentPage) ? getters.currentPage.id : null
        //const postType = getters.currentPostType;
        //if (!pageID && postType) pageID = archivePageId(postType)
        return (pageID) ? Number(pageID) : null;
    },

    currentPage: (state, getters) => {
        let page = {}

        const router = getters.getCurrentRoute;
        let postType = (router.meta.type === 'archive') ? 'page' : getters.currentPostType;
        //get revision
        if(router && router.query && router.query.preview === 'true' && router.query.nonce && router.query.post_id){
            postType = 'revision';
            let pageToFind = Number(router.query.post_id)
            
            if (state.postsData && postType) {
                page = state.postsData[postType] ? state.postsData[postType].find(it => (pageToFind) === it.parent) : {};
            }
        }else{

            if (state.postsData && postType) {
                const pagePath = state.route.path;
                const currentPageUrl = WPVUE.home.replace(/\/$/, "") + '' + pagePath.replace(/\/$/, "") 
                let pageToFind = null
                switch (router.name) {
                    case 'frontPage':
                            pageToFind = Number(router.meta.id)
                            page = state.postsData[postType] ? state.postsData[postType].find(it => (pageToFind) === it.id) : {};
                        break;
                
                    default:
                        page = state.postsData[postType] ? state.postsData[postType].find(it => (currentPageUrl) === it.link.replace(/\/$/, "")) : {};
                        break;
                }
            }
        }
        
        return page;
    },
    /**
     * 
     */
    storedTaxonomy: state => (taxName = 'category' , taxId) => {
        let taxonomy = [];
        if(state.taxonomies && state.taxonomies[taxName] && state.taxonomies[taxName].length){
            if(taxId) taxonomy = state.taxonomies[taxName].find(el => (Number(el.id) === Number(taxId)) )
            else taxonomy = state.taxonomies[taxName]
        }

        return taxonomy;
    },

    /**
     * @param  {string} taxName='category'
     * @param  {mixed-> array or string} slug=''
     */
    storedTaxonomyBySlug: state => (taxName = 'category' , slug = '') => {
        let taxonomy = []
        if(!slug) return taxonomy
        if(state.taxonomies && state.taxonomies[taxName] && state.taxonomies[taxName].length){
            if(Array.isArray(slug)){
                taxonomy = slug.map(sl=> state.taxonomies[taxName].find(el => (el.slug === sl) ))
            }else{
                taxonomy = state.taxonomies[taxName].find(el => (el.slug === slug) )
            }
        }

        return taxonomy;
    },
    getMenu: state => location => {
        let menu = [];
        if(location && state.menus && state.menus[location]){
            menu = state.menus[location]
        }
        return menu
    }
}